/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Service for store and retrieve an specific geopolitical view.
 *
 * This service is used by map instances, widgets and services to store their geopolitical
 * view configuration.
 *
 * If its constructor receive a GeopolViewService instance as argument it will start listen changes in the
 * given instance and apply the same change in its own. That behavior allows the instances of this class to
 * be updated in cascade.
 *
 * @class GeopolViewService
 * @module Services
 * @extends L.Evented
 * @constructor
 * @param {GeopolViewService} [parent] If is defined makes the new instance a "slave" of the given instance
 */
/* jshint nomen:false */
define(['./geopolView', 'leaflet', './geopolViewsMapping', 'services/utils'],
    function(GeopolView, L, geopolViewsMapping, Utils) {
        'use strict';
        var GeopolViewService;
        var defaultGeopolViewCode = 'Unified';
        var EVENTS = {
            /**
             * Fired after the view was changed.
             * @event GEOPOL_VIEW_CHANGED
             * @type String
             *
             * @example
             * ```javascript
             * var geopolViewService = new GeopolViewService();
             * geopolViewService.on(L.GeopolViewService.Events.GEOPOL_VIEW_CHANGED, function(eventData) {
             *  console.log(eventData);
             * });
             * ```
             */
            'GEOPOL_VIEW_CHANGED': 'config.geopolView.changed'
        };
        /**
         * @ignore
         * @return {GeopolView}
         */
        function getDefaultGeopolView() {
            return new GeopolView(defaultGeopolViewCode);
        }

        GeopolViewService = L.Evented.extend({

            Events: EVENTS,

            initialize: function(parent) {
                if (parent instanceof GeopolViewService) {
                    this.current = new GeopolView(parent.getCurrentGeopolView().getCode());
                    this._enslaveTo(parent);
                } else {
                    this.current = getDefaultGeopolView();
                }
            },

            /**
             * Sets the current geopolitical view.
             *
             * It also fires the event
             * {{#crossLink "GeopolViewService/GEOPOL_VIEW_CHANGED:event"}}{{/crossLink}}.
             *
             * @method setCurrentGeopolView
             * @param {String|GeopolView} [geopolView='Unified'] view code or a GeopolView instance
             */
            setCurrentGeopolView: function(geopolView) {
                if (Utils.isString(geopolView)) {
                    geopolView = new GeopolView(geopolView);
                }
                if (this.current.getCode() !== geopolView.getCode()) {
                    this.current = new GeopolView(geopolView.getCode());
                    this.fire(EVENTS.GEOPOL_VIEW_CHANGED, this.current);
                }
            },

            /**
             * Returns the current geopolitical view stored in the instance.
             *
             * @method getCurrentGeopolView
             * @return {GeopolView}
             */
            getCurrentGeopolView: function() {
                return this.current;
            },

            cleanEvents: function() {
                if (this.parent) {
                    this.parent.off(EVENTS.GEOPOL_VIEW_CHANGED, this.setCurrentGeopolView, this);
                    this.parent = undefined;
                }
                this.off();
            },

            /**
             * Make this instance a slave of another GeopolViewService instance.
             * What it basically means is that this instance will copy the current
             * geopolitical view of the parent instance when it changes.
             *
             * @ignore
             * @param {GeopolViewService} parent
             */
            _enslaveTo: function(parent) {
                this.parent = parent;
                parent.on(EVENTS.GEOPOL_VIEW_CHANGED, this.setCurrentGeopolView, this);
            }
        });

        /**
         * Static method that returns an array with the supported geopolitical views for the given service.
         *
         * Note: If no arguments are passed to this function it will return ALL the geopolitical views available
         * whether they are supported by a particular service or not. This was kept for backward compatibility.
         *
         * @static
         * @method GeopolViewService.getSupportedViews
         * @param {"search"|"maps"|"reverseGeocoder"} serviceType
         * @param {"raster"|"vector"|"all"} [subType] Only available for maps - Used to specify the subType of a
         * service, for example 'maps - raster' (If you pass 'all' it returns all the geopol views for the given
         * serviceType)
         * @return {GeopolView[]}
         */
        GeopolViewService.getSupportedViews = function(serviceType, subType) {
            var supportedServices = GeopolView.getSupportedServices();
            var supportedViews = [];
            subType = subType || 'all';

            // we keep this for backward compatibility
            if (arguments.length === 0) {
                return Object.keys(geopolViewsMapping).map(function(view) {
                    return new GeopolView(view);
                });
            }

            if (supportedServices.indexOf(serviceType) === -1) {
                console.warn(serviceType + ' is not supported. Supported services: ' + supportedServices.join(', '));
                return [];
            }

            if ((serviceType !== 'maps' && subType !== 'all') ||
                (serviceType === 'maps' && ['raster', 'vector', 'all'].indexOf(subType) === -1)) {
                console.warn('Please specify a valid subType for this service. ' +
                    'Expecting: raster, vector or all (for the full list). Returning undefined.');
                return [];
            }

            Object.keys(geopolViewsMapping).forEach(function(view) {
                var viewMapping = geopolViewsMapping[view][serviceType];

                if (viewMapping && subType !== 'all') {
                    viewMapping = viewMapping[subType];
                }

                if (viewMapping && viewMapping.fallback) {
                    return;
                }

                supportedViews.push(new GeopolView(view));
            });

            return supportedViews;
        };

        GeopolViewService.Events = EVENTS;

        Utils.addDeprecatedProperty(GeopolViewService.prototype, 'EVENTS', 'Events');

        /**
         * Leaflet factory of this service.
         *
         * @param {GeopolViewService} parent
         * @return {GeopolViewService}
         */
        L.geopolViewService = function(parent) {
            return new GeopolViewService(parent);
        };

        L.GeopolViewService = GeopolViewService;

        return L.GeopolViewService;
    });



// WEBPACK FOOTER //
// ./config/geopolView/geopolViewService.js